import { render, staticRenderFns } from "./NoProductLinks.vue?vue&type=template&id=2cb33947&scoped=true&"
import script from "./NoProductLinks.vue?vue&type=script&lang=js&"
export * from "./NoProductLinks.vue?vue&type=script&lang=js&"
import style0 from "./NoProductLinks.vue?vue&type=style&index=0&id=2cb33947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb33947",
  null
  
)

export default component.exports